import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, rupiah, PASS_RULES, TOTAL_METHODS } from "@/lib/api";
import { Empty, NativeSelect, Spinner } from "@/components/Brand";
import { Confirm } from "@/components/Confirm";
import { GoldBtn, PageTitle } from "@/pages/admin/AdminLayout";

const ST = { draft: "bg-slate-200 text-slate-700", active: "bg-emerald-100 text-emerald-700", inactive: "bg-red-100 text-red-700" };
const STL = { draft: "Draf", active: "Aktif", inactive: "Nonaktif" };

export default function PackagesAdmin() {
  const nav = useNavigate();
  const [cats, setCats] = useState([]);
  const [cat, setCat] = useState("");
  const [rows, setRows] = useState(null);
  const load = () => api.get("/admin/packages", { params: cat ? { category_id: cat } : {} }).then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => {
    api.get("/categories", { params: { all: true } }).then((r) => setCats(r.data));
  }, []);
  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cat]);
  const del = async (p) => {
    try {
      await api.delete(`/admin/packages/${p.id}`);
      toast.success("Paket dihapus");
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div>
      <PageTitle title="Paket Tryout" desc="Buat paket sebanyak yang diperlukan untuk setiap kategori.">
        <GoldBtn onClick={() => nav("/admin/paket/baru")} data-testid="package-add-btn"><Plus className="h-4 w-4" />Buat Paket</GoldBtn>
      </PageTitle>
      <div className="mb-4 max-w-xs"><NativeSelect value={cat} onChange={(e) => setCat(e.target.value)} data-testid="packages-category-filter"><option value="">Semua kategori</option>{cats.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}</NativeSelect></div>
      {!rows ? <Spinner /> : rows.length === 0 ? <Empty text="Belum ada paket." /> : (
        <div className="overflow-x-auto rounded-xl border bg-white">
          <table className="w-full min-w-[900px] text-sm" data-testid="packages-table">
            <thead className="bg-slate-50 text-left text-xs uppercase text-slate-500"><tr><th className="px-4 py-3">Paket</th><th>Kategori</th><th>Materi</th><th>Soal</th><th>Durasi</th><th>Harga</th><th>Akses</th><th>Total / Kelulusan</th><th>Status</th><th className="pr-4 text-right">Aksi</th></tr></thead>
            <tbody>{rows.map((p) => (
              <tr key={p.id} className="border-t" data-testid={`package-row-${p.id}`}>
                <td className="px-4 py-3 font-semibold">{p.name}</td><td>{p.category_name}</td>
                <td className="text-xs">{p.sections.map((s) => s.code || s.name).join(", ")}</td>
                <td>{p.question_count}</td><td>{p.duration_minutes} mnt</td><td>{rupiah(p.price)}</td>
                <td>{p.access_mode === "all" ? "Semua peserta" : `${p.allowed_user_ids.length} peserta`}</td>
                <td className="text-xs">{TOTAL_METHODS[p.total_method]}<br /><span className="text-slate-500">{PASS_RULES[p.pass_rule]}</span></td>
                <td><span className={`rounded-full px-2 py-0.5 text-xs font-bold ${ST[p.status]}`}>{STL[p.status]}</span></td>
                <td className="pr-4 text-right">
                  <button onClick={() => nav(`/admin/paket/${p.id}`)} className="mr-2" data-testid={`package-edit-${p.id}`}><Pencil className="h-4 w-4 text-slate-600" /></button>
                  <Confirm testid={`package-delete-${p.id}`} title="Hapus paket?" description="Paket yang sudah memiliki hasil ujian tidak dapat dihapus; nonaktifkan saja agar riwayat tetap tersimpan." onConfirm={() => del(p)}
                    trigger={<button data-testid={`package-delete-btn-${p.id}`}><Trash2 className="h-4 w-4 text-red-600" /></button>} />
                </td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}
